import React, { Component } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Row, Col, Avatar, Dropdown, Menu, Select } from "antd";
import { navigationAction } from "../body/Navigation";
import { history, getUser, strings } from "../../helpers";

// Top Nav Component

const { Option } = Select;

class TopNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      languages: [
        { key: 0, text: "English", value: "en" },
        { key: 1, text: "Hindi", value: "hi" },
        { key: 2, text: "Punjabi", value: "pb" }
      ],
      current_language: localStorage.getItem("lang")
        ? localStorage.getItem("lang")
        : "en"
    };
  }

  /**
   * @function logoutUser
   * @return nothing
   * @desc This function logouts the user
   */
  logoutUser = () => {
    this.props.logout();
  };

  /**
   * @function changeLanguage
   * @param value
   * @return nothing
   * @desc This function sets the Language preference
   */
  changeLanguage = value => {
    this.props.changeLanguage(value);
    localStorage.setItem("lang", value);
  };

  goToDashboard = (e) => {
    if(e) e.preventDefault();
    history.push("/");
  };

  /**
   * @function goToSignIn
   * @desc This function handles redirection of user when user clicks on sign in link from top nav
   */
  goToSignIn = () => {
    history.push("/sign-in");
  };

  /**
   * @function menuClick
   * @return nothing
   * @desc This function handles redirections when user clicks on top right user menu
   */
  menuClick = e => {
    if (e.key === "1") {
      this.props.logout();
    }
  };

  render() {
    const menu = (
      <Menu onClick={this.menuClick}>
        <Menu.Item key="1">
          <span>{strings.topNav.sign_out}</span>
        </Menu.Item>
      </Menu>
    );

    return (
      <div>
        <Row type="flex" justify="start" align="middle">
          <Col span={8}>
            <a href="" onClick={this.goToDashboard}>
              <span className="unselectable top-logo">
                {" "}
                <img
                  src={require("../../images/kc_logo_green.png")}
                  alt="kulcare logo"
                />
              </span>
            </a>
          </Col>

          <Col span={16} className="text-right top-right-col">
            <Row type="flex" justify="end" align="middle" gutter={20}>
              {getUser() && (
                <Col id="avator" className="avator-wrapper">
                  <Dropdown
                    overlay={menu}
                    trigger={["click"]}
                    getPopupContainer={() => document.getElementById("avator")}
                  >
                    <a
                      className="ant-dropdown-link top-user-avatar"
                      href=""
                    >
                      <Avatar
                        size="small"
                        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PGNpcmNsZSBpZD0iYSIgY3g9IjE1IiBjeT0iMTUiIHI9IjE1Ii8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHVzZSBmaWxsPSIjRkZGIiB4bGluazpocmVmPSIjYSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiIG1hc2s9InVybCgjYikiPjxwYXRoIGZpbGw9IiM1MjVGN0YiIGQ9Ik0xMiAxNC4zMDhhNS4wNzcgNS4wNzcgMCAxIDAgMC0xMC4xNTQgNS4wNzcgNS4wNzcgMCAwIDAgMCAxMC4xNTR6Ii8+PHBhdGggZmlsbD0iI0FBQjdDNCIgZD0iTTIwLjkxNiAyMC4wMzJBMTEuOTcgMTEuOTcgMCAwIDEgMTIgMjRhMTEuOTcgMTEuOTcgMCAwIDEtOC45MTYtMy45NjhDNC4xNCAxOC4wNjQgNy43MzIgMTYuNjE1IDEyIDE2LjYxNWM0LjI2OCAwIDcuODYgMS40NDkgOC45MTYgMy40MTd6Ii8+PC9nPjwvZz48L3N2Zz4="
                      />
                    </a>
                  </Dropdown>
                </Col>
              )
              // : (
              //   <Col>
              //     <a
              //       href="javascript:;"
              //       onClick={this.goToSignIn}
              //       className="signin-text"
              //     >
              //       Sign in
              //     </a>
              //   </Col>
              // )}
              }
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    IsUserLoggedIn: state.login.user_logged_in,
    translate: getTranslate(state.locale)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    navigateTo: (page, tab) => dispatch(navigationAction(page, tab))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TopNav);
